module.exports = __webpack_public_path__ + "static/media/questionnaire_complete.e2db879e.png";